export default __webpack_public_path__ + "static/lutein_retina_bulb_thumb-3b09b9d65163b872ec6648b9b331c776.jpg";